interface IFreeBadget extends React.HTMLProps<HTMLDivElement> {
  children?: any;
  selected: boolean;
  // Здесь можно добавить дополнительные пропсы, если необходимо
}
export const FreeBadget = ({ children,selected, ...props }: IFreeBadget) => {
  return (
    <div
      className={
        "full-list-of-tags-item free-button " +
        (selected == true ? "free-button-active" : "")
      }
      {...props}
    >
      <div className="full-list-of-tags-item-text">
        free
        {children}
      </div>
    </div>
  );
};
